module.exports = __webpack_public_path__ + "media/images/front/treatment_support/menu-ae1f356e2e134f4e13aeea0a207a86de.svg";